import React from 'react';

const Navbar = () => {
   return (
      <div className="navbar  text-white">
  <div className="navbar-start">
    <div className="dropdown">
      <label tabIndex={0} className="btn btn-ghost lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
      </label>
      <ul tabIndex={0} className="menu menu-compact dropdown-content text-gray-300 mt-3 p-2 shadow bg-black glass rounded-box w-60">
        <li><a href='/'>Home</a></li>
        <li><a href='#about-me'>About Me</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#contact-me'>Contact Me</a></li>
      </ul>
    </div>
  </div>
  <div className="navbar-center hidden lg:flex">
    <ul className="menu menu-horizontal px-1 text-gray-300">
      <li><a href='/'>Home</a></li>
        <li><a href='#about-me'>About Me</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#contact-me'>Contact Me</a></li>
    </ul>
  </div>
  <div className="navbar-end mr-5">
    <a href='https://drive.google.com/file/d/1A3zpCkU9yQfG-K5x3KA9JA4KwmicXQsE/view?usp=share_link'><button className='btn btn-warning btn-outline btn-sm'>Resume</button></a>
  </div>
</div>
   );
};

export default Navbar;
